import * as stylex from "@stylexjs/stylex";

import type { PropsWithStyleX } from "../../styles/tokens.stylex";

type IPulseLoading = {
    id?: string;
    stylexItem?: stylex.StyleXStyles;
    pulseNumber?: number;
};

export default function PulseLoading(props: PropsWithStyleX & IPulseLoading) {
    const numberElements = props.pulseNumber || 1;

    const children = new Array(numberElements);

    for (let i = 0; i < numberElements; i++) {
        children[i] = <div key={i} {...stylex.props(styles.elementEffect, props.stylexItem)} />;
    }

    return (
        <div
            {...stylex.props(
                styles.wrapper,
                numberElements > 1 ? styles.multipleLines : styles.oneLine,
                props.styleX,
            )}
        >
            {children}
        </div>
    );
}

const keyframe = stylex.keyframes({
    "0%": {
        backgroundPosition: "-50% 0",
    },

    "100%": {
        backgroundPosition: "50% 0",
    },
});

const styles = stylex.create({
    wrapper: {
        width: "100%",
    },

    multipleLines: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
    },

    oneLine: {
        height: "100%",
    },

    elementEffect: {
        backgroundImage: "linear-gradient(230deg, #E6E6E6 5%, #F6F6F6 10%, #E6E6E6 35%)",
        animationName: keyframe,
        animationDuration: "2s",
        animationTimingFunction: "linear",
        animationIterationCount: "infinite",
        animationDirection: "reverse",
        animationFillMode: "forwards",
        position: "relative",
        backgroundSize: "4000px",
        height: "100%",
        margin: "0",
    },
});
